var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35b18c;}.cls-2{fill:#b27033;}.cls-3{fill:#79c29f;}.cls-4{fill:#329373;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_534",
    "data-name": "Warstwa 534"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.67,24.38l-3.89-6.17h1.46a.5.5,0,0,0,.42-.76l-3.29-5.3h.88a.49.49,0,0,0,.42-.75L18.14,7.16,15.57,2.88a.49.49,0,0,0-.85,0L12.15,7.16,9.62,11.4a.49.49,0,0,0,.42.75h.88l-3.29,5.3a.5.5,0,0,0,.42.76H9.51L5.62,24.38a.5.5,0,0,0,.43.77H24.24A.5.5,0,0,0,24.67,24.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.59,
    y: 25.15,
    width: 3.01,
    height: 4.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.86,5.22l3.35,5.64a.26.26,0,0,1-.21.34H15.79v-.69a.86.86,0,0,0,.62-.85l-1-4.3C15.4,5.13,15.76,5,15.86,5.22Zm5,11.36a4.13,4.13,0,0,0-4.12-4.13h-5.3a.18.18,0,0,0-.06.36c1.53.51,4.17,1.54,5,2.85a4.65,4.65,0,0,1,.79,1.49l3.68,0Zm1.25,6a3.94,3.94,0,0,0-3.94-3.95h-7.8a.26.26,0,0,0-.06.51c2.73.55,6.53,1.53,7.33,2.7a3.87,3.87,0,0,1,.87,2.28h3.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.72,
    y: 11.16,
    width: 4.82,
    height: 1,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 13.47,
    y: 17.17,
    width: 7.72,
    height: 1,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.23,
    y: 23.24,
    width: 10.83,
    height: 1,
    rx: 0.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.8024e796a3b9175883e75f4a8fd7c3fc.svg";
export { ForwardRef as ReactComponent };